/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import CommunityControllerDtoPostAccountSearchRequest from '../model/CommunityControllerDtoPostAccountSearchRequest';
import CommunityControllerDtoPostAccountSearchResponse from '../model/CommunityControllerDtoPostAccountSearchResponse';
import CommunityControllerDtoPostCreateFromExcelResponse from '../model/CommunityControllerDtoPostCreateFromExcelResponse';
import CommunityControllerDtoPostCreateResponse from '../model/CommunityControllerDtoPostCreateResponse';
import CommunityControllerDtoPostDetailRequest from '../model/CommunityControllerDtoPostDetailRequest';
import CommunityControllerDtoPostDetailResponse from '../model/CommunityControllerDtoPostDetailResponse';
import CommunityControllerDtoPostExcelDownloadRequest from '../model/CommunityControllerDtoPostExcelDownloadRequest';
import CommunityControllerDtoPostListRequest from '../model/CommunityControllerDtoPostListRequest';
import CommunityControllerDtoPostListResponse from '../model/CommunityControllerDtoPostListResponse';
import CommunityControllerDtoPostRemoveRequest from '../model/CommunityControllerDtoPostRemoveRequest';
import PostItemData from '../model/PostItemData';
import PostUserData from '../model/PostUserData';

/**
* PerplayCommunity service.
* @module api/PerplayCommunityApi
* @version 1.0
*/
export default class PerplayCommunityApi {

    /**
    * Constructs a new PerplayCommunityApi. 
    * @alias module:api/PerplayCommunityApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayCommunityPostAccountSearchPost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostAccountSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommunityControllerDtoPostAccountSearchResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CommunityControllerDtoPostAccountSearchRequest} [communityControllerDtoPostAccountSearchRequest] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostAccountSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommunityControllerDtoPostAccountSearchResponse}
     */
    apiPerplayCommunityPostAccountSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['communityControllerDtoPostAccountSearchRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CommunityControllerDtoPostAccountSearchResponse;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostAccountSearch', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCommunityPostCreateFromExcelPost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostCreateFromExcelPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommunityControllerDtoPostCreateFromExcelResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {String} [perTransactionHash] 
     * @param {String} [xperTransactionHash] 
     * @param {File} [excelFile] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostCreateFromExcelPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommunityControllerDtoPostCreateFromExcelResponse}
     */
    apiPerplayCommunityPostCreateFromExcelPost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'PerTransactionHash': opts['perTransactionHash'],
        'XperTransactionHash': opts['xperTransactionHash'],
        'ExcelFile': opts['excelFile']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CommunityControllerDtoPostCreateFromExcelResponse;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostCreateFromExcel', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCommunityPostCreatePost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommunityControllerDtoPostCreateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} [userDataType] 
     * @param {File} [excelFile] 
     * @param {Date} [sentAt] 
     * @param {Date} [expireAt] 
     * @param {String} [title] 
     * @param {String} [content] 
     * @param {Number} [per] 
     * @param {Number} [xper] 
     * @param {module:model/MailTypes} [mailType] 
     * @param {Number} [eventNo] 
     * @param {Number} [walletNo] 
     * @param {Number} [initialPer] 
     * @param {Number} [initialXper] 
     * @param {Number} [depositTransactionStatus] 
     * @param {Array.<module:model/PostItemData>} [items] 
     * @param {Array.<module:model/PostUserData>} [users] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommunityControllerDtoPostCreateResponse}
     */
    apiPerplayCommunityPostCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'UserDataType': opts['userDataType'],
        'ExcelFile': opts['excelFile'],
        'SentAt': opts['sentAt'],
        'ExpireAt': opts['expireAt'],
        'Title': opts['title'],
        'Content': opts['content'],
        'Per': opts['per'],
        'Xper': opts['xper'],
        'MailType': opts['mailType'],
        'EventNo': opts['eventNo'],
        'WalletNo': opts['walletNo'],
        'InitialPer': opts['initialPer'],
        'InitialXper': opts['initialXper'],
        'DepositTransactionStatus': opts['depositTransactionStatus'],
        'Items': this.apiClient.buildCollectionParam(opts['items'], 'multi'),
        'Users': this.apiClient.buildCollectionParam(opts['users'], 'multi')
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CommunityControllerDtoPostCreateResponse;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCommunityPostDetailPost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommunityControllerDtoPostDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CommunityControllerDtoPostDetailRequest} [communityControllerDtoPostDetailRequest] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommunityControllerDtoPostDetailResponse}
     */
    apiPerplayCommunityPostDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['communityControllerDtoPostDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CommunityControllerDtoPostDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCommunityPostExcelDownloadPost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostExcelDownloadPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CommunityControllerDtoPostExcelDownloadRequest} [communityControllerDtoPostExcelDownloadRequest] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostExcelDownloadPostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    apiPerplayCommunityPostExcelDownloadPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['communityControllerDtoPostExcelDownloadRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostExcelDownload', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCommunityPostListPost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommunityControllerDtoPostListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CommunityControllerDtoPostListRequest} [communityControllerDtoPostListRequest] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommunityControllerDtoPostListResponse}
     */
    apiPerplayCommunityPostListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['communityControllerDtoPostListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = CommunityControllerDtoPostListResponse;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayCommunityPostRemovePost operation.
     * @callback module:api/PerplayCommunityApi~apiPerplayCommunityPostRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CommunityControllerDtoPostRemoveRequest} [communityControllerDtoPostRemoveRequest] 
     * @param {module:api/PerplayCommunityApi~apiPerplayCommunityPostRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayCommunityPostRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['communityControllerDtoPostRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayCommunity/PostRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
